module.exports = __webpack_public_path__ + "static/media/preview_coupon_campaign_8.05001b45.svg";